<div class="nw-executive-members__container">
    <h2>{{ heading }}</h2>
    @if (text) {
        <p class="nw-executive-members__container__text">
            {{ text }}
        </p>
    }
    <div class="nw-executive-members__container__members">
        @let gridSize = gridSize$ | async;
        @for (member of members; track $index) {
            <div
                class="nw-executive-members__container__members__member"
                [style.order]="$index"
                [class.nw-executive-members__container__members__member--active]="
                    selectedIndex === $index
                "
                (click)="
                    selectedIndex === $index
                        ? (selectedIndex = undefined)
                        : (selectedIndex = $index)
                "
                (keydown)="
                    selectedIndex === $index
                        ? (selectedIndex = undefined)
                        : (selectedIndex = $index)
                "
                (mouseenter)="focusIndex = $index"
                (mouseleave)="focusIndex = -1"
                (focus)="focusIndex = $index"
                (blur)="focusIndex = -1"
                tabindex="-1"
            >
                <img
                    [ngSrc]="member.pictureUrl"
                    height="200"
                    width="200"
                    [alt]="member.name"
                    class="nw-executive-members__container__members__member__picture"
                    [id]="'member' + id + $index"
                />
                <h4 class="nw-executive-members__container__members__member__name">
                    {{ member.name }}
                </h4>
                @if (member.jobTitle) {
                    <span
                        class="nw-executive-members__container__members__member__job-title"
                    >
                        {{ member.jobTitle }}
                    </span>
                }
            </div>
            <div
                [style.display]="selectedIndex === $index ? undefined : 'none'"
                [style.order]="$index | memberOrder: $any(gridSize)"
                [style.gridColumn]="'span ' + gridSize + ' / span ' + $any(gridSize)"
                class="nw-executive-members__container__members__bio"
                [innerHTML]="member.bio | sanitizeHtml"
            ></div>
        }
    </div>
</div>
